// Default namespaces
export let ns = 'http://www.w3.org/2000/svg'
export let xmlns = 'http://www.w3.org/2000/xmlns/'
export let xlink = 'http://www.w3.org/1999/xlink'
export let svgjs = 'http://svgjs.com/svgjs'
